import React from "react";
import { Route, Redirect } from "react-router-dom";

import { connect } from "react-redux";

import { getAuthenticated, getHasFeatureFlags } from "containers/Login/reducer";

import { decodeUiState } from "containers/ChatApp/reducer";

import queryString from "query-string";

const ProtectedRoute = ({ isAuthenticated, hasFeatureFlags, component, location, allowUiState, ...rest }) => {
  const params = location?.search ?? "";
  const child = hasFeatureFlags ? component : () => React.Fragment;

  let shouldRenderChild = isAuthenticated;

  // if (!shouldRenderChild && allowUiState) {
  //     const queryParams = location?.search;
  //     const paramsObj = queryParams ? queryString.parse(queryParams) : undefined;

  //     if (paramsObj?.["ui-state"]) {
  //         const uiState = decodeUiState(paramsObj?.["ui-state"]);
  //         if (uiState?.type === allowUiState) {
  //             shouldRenderChild = true;
  //         }
  //     }
  // }

  return (
    <Route
      {...rest}
      component={
        shouldRenderChild
          ? child
          : () => (
              <Redirect
                to={{
                  pathname: "/login",
                  state: { from: location },
                  search: params
                }}
              />
            )
      }
    />
  );
};

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: getAuthenticated(state),
    hasFeatureFlags: getHasFeatureFlags(state)
  };
}

export default connect(mapStateToProps)(ProtectedRoute);
